// /src/mocks/estandares.ts
import { IEstandar } from '../types';

export const mockEstandares: IEstandar[] = [
  {
    id: 'estandar-1',
    nombre: 'ISO 45001:2018 - Sistema de Gestión de Seguridad y Salud en el Trabajo',
    capitulos: [
      {
        id: 'cap-1',
        nombre: '4. Contexto de la Organización',
        lineamientos: [
          {
            id: 'lin-1-1',
            nombre: '4.1 Comprensión de la organización y su contexto',
            descripcion: 'La organización debe determinar las cuestiones externas e internas pertinentes a su propósito.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
          {
            id: 'lin-1-2',
            nombre: '4.2 Comprensión de las necesidades y expectativas de los trabajadores',
            descripcion: 'La organización debe determinar las partes interesadas y sus requisitos.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
          {
            id: 'lin-1-3',
            nombre: '4.3 Determinación del alcance del sistema de gestión',
            descripcion: 'La organización debe determinar los límites y la aplicabilidad del sistema.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
        ],
      },
      {
        id: 'cap-2',
        nombre: '5. Liderazgo y Participación de los Trabajadores',
        lineamientos: [
          {
            id: 'lin-2-1',
            nombre: '5.1 Liderazgo y compromiso',
            descripcion: 'La alta dirección debe demostrar liderazgo y compromiso con el sistema de gestión.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
          {
            id: 'lin-2-2',
            nombre: '5.2 Política de SST',
            descripcion: 'La alta dirección debe establecer, implementar y mantener una política de SST.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
          {
            id: 'lin-2-3',
            nombre: '5.3 Roles, responsabilidades y autoridades',
            descripcion: 'La alta dirección debe asegurar que las responsabilidades y autoridades se asignen y comuniquen.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
          {
            id: 'lin-2-4',
            nombre: '5.4 Consulta y participación de los trabajadores',
            descripcion: 'La organización debe establecer procesos para la consulta y participación de los trabajadores.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
        ],
      },
      {
        id: 'cap-3',
        nombre: '6. Planificación',
        lineamientos: [
          {
            id: 'lin-3-1',
            nombre: '6.1.1 Generalidades - Acciones para abordar riesgos',
            descripcion: 'La organización debe planificar acciones para abordar riesgos y oportunidades.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
          {
            id: 'lin-3-2',
            nombre: '6.1.2 Identificación de peligros y evaluación de riesgos',
            descripcion: 'La organización debe establecer procesos para la identificación continua de peligros.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
          {
            id: 'lin-3-3',
            nombre: '6.2 Objetivos de SST y planificación para lograrlos',
            descripcion: 'La organización debe establecer objetivos de SST medibles.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
        ],
      },
      {
        id: 'cap-4',
        nombre: '7. Apoyo',
        lineamientos: [
          {
            id: 'lin-4-1',
            nombre: '7.1 Recursos',
            descripcion: 'La organización debe determinar y proporcionar los recursos necesarios.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
          {
            id: 'lin-4-2',
            nombre: '7.2 Competencia',
            descripcion: 'La organización debe asegurar que los trabajadores sean competentes.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
          {
            id: 'lin-4-3',
            nombre: '7.3 Toma de conciencia',
            descripcion: 'Los trabajadores deben ser conscientes de la política de SST y su contribución.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
          {
            id: 'lin-4-4',
            nombre: '7.4 Comunicación',
            descripcion: 'La organización debe establecer procesos de comunicación interna y externa.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
          {
            id: 'lin-4-5',
            nombre: '7.5 Información documentada',
            descripcion: 'El sistema de gestión debe incluir la información documentada requerida.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
        ],
      },
    ],
  },
  {
    id: 'estandar-2',
    nombre: 'ISO 9001:2015 - Sistema de Gestión de Calidad',
    capitulos: [
      {
        id: 'cap-iso9001-1',
        nombre: '4. Contexto de la Organización',
        lineamientos: [
          {
            id: 'lin-iso9001-1-1',
            nombre: '4.1 Comprensión de la organización y su contexto',
            descripcion: 'Determinar cuestiones externas e internas relevantes para el propósito y dirección estratégica.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
          {
            id: 'lin-iso9001-1-2',
            nombre: '4.2 Comprensión de las necesidades y expectativas de las partes interesadas',
            descripcion: 'Determinar las partes interesadas y sus requisitos relevantes.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
        ],
      },
      {
        id: 'cap-iso9001-2',
        nombre: '5. Liderazgo',
        lineamientos: [
          {
            id: 'lin-iso9001-2-1',
            nombre: '5.1 Liderazgo y compromiso',
            descripcion: 'La alta dirección debe demostrar liderazgo y compromiso con el SGC.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
          {
            id: 'lin-iso9001-2-2',
            nombre: '5.2 Política de calidad',
            descripcion: 'Establecer, implementar y mantener una política de calidad.',
            estado: 'No Aplica',
            hallazgo: '',
            recomendacion: '',
            evidencia: '',
            comentarios: [],
          },
        ],
      },
    ],
  },
];
